import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Newspaper, UsersRound, NotebookPen, Plus } from "lucide-react";
import { MobileCreatePost } from "./CreatePost";

const tabs = [
  { path: "/news", icon: Newspaper, label: "News" },
  { path: "/creators", icon: UsersRound, label: "Creators" },
  { path: "/library", icon: NotebookPen, label: "Library" },
];

const FloatingNav = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [navVisible, setNavVisible] = useState(true);
  const [mobileCreateOpen, setMobileCreateOpen] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = (e) => {
      const target = e.target;
      const y =
        target === document || target === document.documentElement
          ? window.scrollY
          : (target.scrollTop ?? 0);
      if (y > lastScrollY.current + 4) setNavVisible(false);
      else if (y < lastScrollY.current - 4) setNavVisible(true);
      lastScrollY.current = y;
    };
    document.addEventListener("scroll", onScroll, {
      passive: true,
      capture: true,
    });
    return () =>
      document.removeEventListener("scroll", onScroll, { capture: true });
  }, []);

  const currentPath = location.pathname;

  return (
    <>
      <MobileCreatePost
        user={user}
        mobileOpen={mobileCreateOpen}
        onMobileClose={() => setMobileCreateOpen(false)}
      />

      <div
        className="ease-[cubic-bezier(0.4,0,0.2,1)] fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2.5 transition-all duration-300"
        style={{
          opacity: navVisible ? 1 : 0,
          transform: `translateX(-50%) translateY(${navVisible ? "0" : "100%"})`,
          pointerEvents: navVisible ? "auto" : "none",
        }}
      >
        <div className="flex items-center gap-0 rounded-full border-0 bg-black/90 px-4 py-1 shadow-[0_4px_30px_rgba(0,0,0,0.08)] ring-1 ring-white/[0.06] backdrop-blur-3xl dark:bg-white dark:shadow-[0_4px_30px_rgba(0,0,0,0.3)] dark:ring-black/[0.06]">
          {tabs.map((tab) => {
            const isActive = currentPath.startsWith(tab.path);
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className={`gap-0.2 flex flex-col items-center justify-center rounded-2xl px-3 py-1.5 transition ${
                  isActive
                    ? "text-white dark:text-gray-900"
                    : "text-white/50 hover:text-white/80 dark:text-gray-900/60 dark:hover:text-gray-900/80"
                }`}
              >
                <tab.icon className="h-[17px] w-[17px]" />
                <span
                  className={`text-[10px] ${isActive ? "font-semibold" : "font-medium"}`}
                >
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>

        <button
          onClick={() => setMobileCreateOpen(true)}
          className="flex h-[50px] w-[50px] items-center justify-center rounded-full border-0 bg-black/90 text-white shadow-[0_4px_30px_rgba(0,0,0,0.08)] ring-1 ring-black/[0.06] backdrop-blur-3xl active:scale-90 dark:bg-white dark:text-gray-900 dark:shadow-[0_4px_30px_rgba(0,0,0,0.3)] dark:ring-white/[0.06] md:hidden"
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
    </>
  );
};

export default FloatingNav;
